import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import ModalBox from '../../shared/modal';
import SelectField from '../../shared/form-elements/select/field';
import InputField from '../../shared/form-elements/input';

const Form = props => {
	return (
		<div className='payouts-transaction-form-wrap payouts-form-in-modal'>
			<form
				className='ui-form payouts-form__main clearfix'
				onSubmit={props.handleSubmit(props.cloneAdmin)}
			>
				<div className='ui-form__element affiliates'>
					<Field
						name='admin_ids'
						placeholder={props.intl('Clone from')}
						component={SelectField}
						searchable={true}
						multi={false}
						options={getSelectedAdminsSelector(props.admins)}
					/>
				</div>
				<div className='ui-form__element affiliates'>
					<Field
						name='email'
						placeholder={props.intl('Email')}
						component={InputField}
					/>
					<Field
						name="name"
						placeholder={ props.intl('Name') }
						component={InputField}
					/>
					<Field
						name='telegram'
						placeholder={props.intl('Telegram')}
						component={InputField}
					/>
					<Field
						name='skype'
						placeholder={props.intl('Skype')}
						component={InputField}
					/>
				</div>
				<button
					className='ui-btn ui-btn-primary apply'
					type='submit'
				>{props.intl('Clone')}</button>
				<button
					className='ui-btn ui-btn-cancel cancel'
					onClick={e => {
						e.preventDefault();
						props.toggleCloneAdminPopup();
					}}
				>{props.intl('Cancel')}</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	admins: PropTypes.array,
	handleSubmit: PropTypes.func,
	distributeAndRemove: PropTypes.func,
	intl: PropTypes.func,
	toggleAffiliateDistributionPopup: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Create admin as clone')}
		body={Form(props)}
		isOpen={props.isClonePopupVisible}
		onClose={props.toggleCloneAdminPopup}
		className='form-modal affiliate-distribution-modal'
	/>;

Main.propTypes = {
	toggleCloneAdminPopup: PropTypes.func,
	isClonePopupVisible: PropTypes.bool,
	intl: PropTypes.func
};

function getSelectedAdminsSelector(admins = []) {
	return async search => ({
		options: admins.filter(adm => !search || adm.label.toLowerCase().includes(search))
	});
}

export default reduxForm({ form: 'cloneAdminForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/clone-admin-popup.js